import React, {Component} from 'react';
import {Modal,Toast} from 'antd-mobile';
import InterCity from '../Home/changeRole/InterCity/index';
import Shunt from '../Home/changeRole/Shunt/index';
import City from '../Home/changeRole/City/index';
import RentCar from '../Home/changeRole/rentCar/index';
import Pick from '../Home/changeRole/Pick/index';
import {dispatcher,checkDriverInsurance,deleteShift,shuntOrder} from "../../service/homeService";
import storage from '../../utils/localStore';
import {connect} from "react-redux";
import './style.less';
const sculpture = require('../../common/image/user.png');
var staticState = '';//静态state数据绑定

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changeRole:false,
            rentCar:false,
            intercity:false,//城际服务
            city:false,//城内服务
            shunt:false,//分流
            pick:false,//接驳业务
            userName:'',
            showMenu:false,//左侧个人中心，默认不显示
            // InterCityData:[],
            phone:'',
            avatar:sculpture,
            userType:[],
            //分流工作台数据
            combineOrder:'',//待派单
            pickOrder:'',//待组合
           historyShiftFlag:'',
           driverInsurance:[],
           insuranceModal:false,
        };
    }

    componentWillMount(){
        if(!this.props.userInfo.token){
          this.props.history.push('/login');
          return;
        }
        if(staticState != ''){//不为空，表示需要加载之前的数据
            this.setState({
                changeRole:staticState.changeRole,
                intercity:staticState.intercity,
                city:staticState.city,
                rentCar:staticState.rentCar,
                shunt:staticState.shunt,
                pick:staticState.pick,
                userName:staticState.userName,
                showMenu:staticState.showMenu,
                // InterCityData:staticState.InterCityData,
                phone:staticState.phone,
                avatar:staticState.avatar,
                userType:staticState.userType,
                combineOrder:staticState.combineOrder,
                pickOrder:staticState.pickOrder,
            });
            setTimeout(() => {
                var changeId = '0';
                if(staticState.intercity){
                    changeId = '1'
                }else if(staticState.city){
                    changeId = '2'
                }else if(staticState.shunt){
                    changeId = '3'
                }else if(staticState.rentCar){
                    changeId = '4'
                }else if(staticState.pick){
                    changeId = '5'
                }
                this.changeRoleFunc();
            }, 0);
        }else{
            this.getDispatcher();
            // this.getInterCityData();
            this.shuntOrder();
        }
    }

    componentDidMount() {
        if (!this.props.userInfo.isLoggedIn) {
            document.location = `js://toLogin?token=${this.props.userInfo.token}`;
        } else {
            this.getDispatcher();
            // this.getInterCityData();
            this.shuntOrder();
        //    var avatar = document.getElementById('avatar')
        }
       this.getDriverInsurance()
    };
    //获取司机保险过期列表
    getDriverInsurance(){
        checkDriverInsurance({token: this.props.userInfo.token}).then((res) => {
            if (res.data.code === '0000' && res.data.data.length > 0) {
                this.setState({driverInsurance:res.data.data,insuranceModal:true})
            }
        })
    }
    //分流工作台数据
    shuntOrder = () =>{
        let params = {
            token: this.props.userInfo.token,
        };
        shuntOrder(params).then((res) => {
            if (res.data.code === '0000') {
                this.setState({
                    combineOrder:res.data.data.CurrentOrdersNoMix,
                    pickOrder:res.data.data.CurrentOrdersNoAllot,
                })
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        })
    }
    //个人中心数据
    getDispatcher(){
        let params = {
           token: this.props.userInfo.token
        };
        dispatcher(params)
            .then((res) => {
                console.log(res)
              
                if (res.data.code === '0000') {
                    if(res.data.data.isLocked == 1){
                        Toast.info('您的账号已被停用，请登录其他账号！',2,document.location = `js://toLogin?token=${this.props.userInfo.token}`);
                    }else{
                        let data = res.data.data;
                        this.setState({
                            userName:data.userName,
                                phone:data.phone,
                                avatar:data.avatar ? data.avatar : sculpture,
                                userType:data.userType,
                        })
                        let rentFlag;
                        this.state.userType.map(e=>{
                            if(e == 1){
                                this.setState({
                                    historyShiftFlag:1
                                })
                            }
                            if(e == 4){
                                rentFlag = true//如果已经有包车业务了，就不用加4
                            }
                        })
                        if(!rentFlag){
                            this.state.userType.push('4')
                        }
                        
                        let integral = data.integral
                        storage.setItem('integral', integral);
                            if(staticState == ''){
                                if (this.state.userType[0] == '1'){
                                    this.setState({
                                        intercity:true,
                                    })
                                }
                                else if (this.state.userType[0] == '2'){
                                    this.setState({
                                        shunt:true
                                    })
                                }
                                else if (this.state.userType[0] == '3'){
                                    this.setState({
                                        city:true
                                    })
                            }
                            else if (this.state.userType[0] == '4'){
                                this.setState({
                                    rentCar:true
                                })
                            }
                            else if (this.state.userType[0] == '5'){
                                this.setState({
                                    pick:true
                                })
                            }
                        }
                    }
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
    //城际子组件路由跳转
    goPage(value,v){
        this.props.userInfo.resetFlag = false;//初始化不刷新数据
        if(true){//todo 判断何时需要保留数据，默认都需要保留数据
            staticState = this.state;
        }else{
            staticState = '';
        }
        
            setTimeout(() => {
                this.props.history.push({pathname:value,shuntType:v,stateData:this.state});
            }, 1);
      
    };
    

    //城际子组件调用modal
    modalShow=(e,res)=>{
        e.stopPropagation(); 
        Modal.alert('提示', '取消该行程后用户将无法下单，是否确认取消？', [
            {text: '取消'},
            {text: '确定', onPress: () => this.delete(res)},
        ]);
    };
     //城际子组件取消行程
    delete = (id) =>{
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "id":id
            }
         };
         deleteShift(params)
             .then((res) => {
                 if (res.data.code === '0000') {
                    Toast.info('取消行程成功');
                    // this.getInterCityData();
                    window.location.reload();
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
             }).catch(function (error) {
             console.log(error);
         });
    };
    goDetail =(id) =>{
        this.props.history.push(`/shiftDetails/${id}`)
    }
    //切换角色
    changeRoleFunc(){
        if(this.state.intercity == true){
            return <InterCity 
                        {...this.state}
                        goPage = {this.goPage.bind(this)}
                        delete = {this.delete.bind(this)}
                        modalShow = {this.modalShow.bind(this)}
                        goDetail = {this.goDetail.bind(this)}
                        // getInterCityData = {this.getInterCityData.bind(this)}
                    />
        }
        else if(this.state.city == true){
            return <City 
                        {...this.props} 
                        goPage = {this.goPage.bind(this)}
                    />
        }
        else if(this.state.shunt == true){
            return <Shunt 
                        goPage = {this.goPage.bind(this)}
                        {...this.state}
                    />
        }
        else if(this.state.rentCar == true){
            return <RentCar 
                        goPage = {this.goPage.bind(this)}
                        {...this.state}
                    />
        }
        else if(this.state.pick == true){
            return <Pick 
                        goPage = {this.goPage.bind(this)}
                        {...this.state}
                    />
        }
    }
    status(){
       if(this.state.changeRole == false){
            return
        }else{
            this.setState({
                changeRole:false,
            })
        }
    };
    changeId(res){
        staticState = '';
        if(res == "1"){
            this.setState({
                intercity:true,
                city:false,
                shunt:false,
                rentCar:false,
                pick:false
            })
        }
        else if(res == "2"){
            this.setState({
                intercity:false,
                city:false,
                shunt:true,
                rentCar:false,
                pick:false
            })
        }
        else if(res == "3"){
            this.setState({
                intercity:false,
                city:true,
                shunt:false,
                rentCar:false,
                pick:false
            })
        }
        else if(res == "4"){
            this.setState({
                intercity:false,
                city:false,
                shunt:false,
                rentCar:true,
                pick:false
            })
        }
        else if(res == "5"){
            this.setState({
                intercity:false,
                city:false,
                shunt:false,
                rentCar:false,
                pick:true
            })
        }
    }
    /**
     * 控制左侧菜单显示与隐藏
     */
    changeShowMenue(){
        if (this.props.userInfo.isLoggedIn) {
            this.setState({
                showMenue:!this.state.showMenue
            });
        }
    }
    renderMenue(){
        if(!this.state.showMenue){
            return null;
        }else{
    
            return (
                <div className="left-menue">
                    <div className="headContent">
                        <div className="avatar"><img id='avatar' src={this.state.avatar}/></div>
                        <div className="info">
                            <div>{this.state.userName}</div>
                            <span>{this.state.phone}</span>
                        </div>
                    </div>
                    <div  className="menu">
                        <div onClick={() => this.skip('/HistoryModule')}>
                            <i className="icon iconfont icondaixiadanjilu"></i>
                            <span>历史记录</span>
                        </div>
                       {/*  {this.state.historyShiftFlag == 1 ?
                            <div onClick={() => this.skip('/historyShift')}>
                                <i className="icon iconfont iconlishibancijilu"></i>
                                <span>历史行程记录</span>
                            </div>
                       :null} */}
                        <div onClick={() => this.skip('/frequentlyPassenger')}>
                            <i className="icon iconfont iconchangyongchengcheren"></i>
                            <span>常用乘车人</span>
                        </div>
                        <div onClick={() => this.skip('/applyInvoice')}>
                            <i className="icon iconfont iconfapiaoguanli"></i>
                            <span>发票管理</span>
                        </div>
                        <div onClick={() => this.skip('/waterBill')}>
                            <i className="icon iconfont iconshujutongji"></i>
                            <span>数据统计</span>
                        </div>
                        <div onClick={()=>this.skip('/auditInspection')}>
                            <i className="icon iconfont iconyaoqingyonghu"></i>
                            <span>自检单审核</span>
                            {/* <div className="inviteFriends">赚积分 <i className="icon iconfont icontiaozhuan"></i></div> */}
                        </div>
                        <div onClick={()=>this.skip('/batchDeleteClass')}>
                            <i className="icon iconfont icona-jianqudingceng6"></i>
                            <span>批量删除排班</span>
                        </div>
                        <div onClick={()=>this.skip('/helpCenter')}>
                            <i className="icon iconfont iconbangzhuzhongxin"></i>
                            <span>帮助中心</span>
                        </div>
                        <div onClick={() => this.skip('/settings')}>
                            <i className="icon iconfont iconshezhi"></i>
                            <span>设置</span>
                        </div>
                    </div>
                </div>
            );
        }
    };
     //路由跳转控制
    skip(params) {
        if (this.props.userInfo.isLoggedIn) {
            if(params == '/frequentlyPassenger'){
                this.props.history.push('/frequentlyPassenger',{type:1});
            }else{
                this.props.history.push(params,this.state.historyShiftFlag);
            }
        } else {
            Toast.info('您尚未登录，请先登录', 2, this.props.history.push('/login'));
        }
    }
    title(res){
        if(res == "1"){
            return "预约出行"
        }
        if(res == "2"){
            return "城内分流"
        } 
        if(res == "3"){
            return "城内服务"
        }
        if(res == "4"){
            return "专车预约"
        }
        if(res == "5"){
            return "接驳业务"
        }
    };
    style(res){
        if(res == "1"){
            return "icon iconfont iconchengji"
        }
        if(res == "2"){
            return "icon iconfont iconchengnei"
        } 
        if(res == "3"){
            return "icon iconfont iconfenliu"
        }
        if(res == "4"){
            return "icon iconfont iconbaochefuwuicon"
        }
        if(res == "5"){
            return "icon iconfont iconjiechekaidan_huaban"
        }
    };
    toNew = () => {
        document.location = `js://toNewsCenter?token=${this.props.userInfo.token}`;
    }
    render() {
        return (
            <div className="homeScreen" onClick={ ()=> this.status()}>
                <div className="navBar">
                    <div onClick={()=> this.changeShowMenue()}><i className="icon iconfont iconmorentouxiang"></i></div>
                    <div>{this.state.userName}</div>
                    <div onClick={()=>this.toNew()}><i className="icon iconfont iconxiaoxi"/></div>
                    <div onClick={ ()=> this.setState({changeRole:!this.state.changeRole})}><i className="icon iconfont iconqiehuan"></i></div>
                </div>
                    {this.changeRoleFunc()}
                {
                    this.state.changeRole ? 
                        <div className="changeRole">
                            {this.state.userType.map((res,i)=>(
                                <div key={i} onClick={()=>this.changeId(res)}><i className={this.style(res)}></i>{this.title(res)}</div>
                            ))}
                        </div> 
                    : null
                }
                {/* 左侧退出菜单 */}
                {this.state.showMenue ?     
                    <div className="left-menue-parent">
                        {this.renderMenue()}
                        <div className="right-empty" onClick={()=> this.changeShowMenue()}></div>
                    </div>
                    : null
                }
                <Modal
                    className="insuranceModal"
                    visible={this.state.insuranceModal}
                    transparent
                    maskClosable={false}
                    onClose={()=>this.setState({insuranceModal: false})}
                    title="提示"
                    footer={[{ text: '知道了', onPress: () => { this.setState({insuranceModal: false})} }]}
                    >
                    <div style={{ maxHeight: 150, overflow: 'scroll' }}>
                        <div>以下司机的保险即将过期，请提醒！</div>
                       {
                           this.state.driverInsurance.map((res)=>{
                               return <span>{res + "、"}</span>
                           })
                       }
                    </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/index.js